"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVAILABILITY = void 0;
var AVAILABILITY = {
  TEXT__OUTLET_NAME: 'availability-text-outletName',
  BUTTON__SELECT: 'availability-button-selectOutlet',
  BUTTON__SELECT_ALL: 'availability-button-selectAll',
  BUTTON__DESELECT_ALL: 'availability-button-deselectAll'
};
exports.AVAILABILITY = AVAILABILITY;